// export function formatPrice(val, num, isNegative) {
//   num = typeof (num) !== 'undefined' ? num : 2
//   isNegative = typeof (isNegative) !== 'undefined' ? isNegative : true
//   if (num <= 0) {
//     val = val.replace(/[^\d]/g, '')// 清除'数字'以外的字符
//   } else if (isNegative === true) {
//     val = val.replace(/[^\-\d.]/g, '') // 清除'数字'、'-'和'.'以外的字符
//   } else {
//     val = val.replace(/[^\d.]/g, '') // 清除'数字'和'.'以外的字符
//   }
//   val = val.replace(/^\./g, '') // 验证第一个字符是数字
//   val = val.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
//   val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
//   val = val.replace(eval('/^(\\-)*(\\d+)\\.(\\d{0,' + num + '}).*$/'), '$1$2.$3') // 只能输入两个小数
//   val = val.replace(/^0+$/, '0') // 输入全是0替换成1个0
//   if (/^0\d+/.test(val)) {
//     val = val.replace(/^0*/, '')
//   }
//   return val
// }

export function browserType() {
  var browser = {
    versions: function () {
      var u = navigator.userAgent;
      return {//移动终端浏览器版本信息   
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端  
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器  
        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器  
        iPad: u.indexOf('iPad') > -1, //是否iPad  
      };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  }

  if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
    //alert("ios");
    //调用IOS的jumpjumpNext（）方法  
    //window.location.href = 'hm://jumpNext';  
    return "ios";
  } else if (browser.versions.android) {
    //alert("android");			
    //调用Android的jumpjumpNext（）方法  
    //window.compony.jumpNext();   
    return "android";
  }
  return "other";

}

export function colorRgb(color) {
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  var sColor = color.toLowerCase();

  let colorObj = null;
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    //处理六位的颜色值
    var sColorChange = [];
    //渐变色
    var gradualChangeColor = [];

    for (var i = 1; i < 7; i += 2) {
      let rgbValue = parseInt("0x" + sColor.slice(i, i + 2));
      sColorChange.push(rgbValue);
      gradualChangeColor.push(rgbValue - 70);
    }

    colorObj = {
      colorRgb: "rgb(" + sColorChange.join(",") + ")",
      gcColorRgb: "rgb(" + gradualChangeColor.join(",") + ")",
    }
  } else {
    // empty color rgb
    colorObj = {
      colorRgb: sColor,
      gcColorRgb: sColor,
    }
  }

  return colorObj;
}

//将base64转换为file
export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

// 压缩图片
export function compressImage(file) {
  return new Promise((resolve) => {
    let canvas = document.createElement("canvas"); // 创建Canvas对象(画布)
    let context = canvas.getContext("2d");
    let img = new Image();
    img.src = file.content; // 指定图片的DataURL(图片的base64编码数据)
    img.onload = function () {

      // 画布大小 这里的this指向img
      canvas.width = this.width;
      canvas.height = this.height;
      context.drawImage(img, 0, 0, this.width, this.height); // 图片大小
      file.content = canvas.toDataURL(file.file.type, 0.4); // 0.92为默认压缩质量
      
      // 赋值bas64
      let form = {
        picture: ""
      }
      form.picture = file.content;
      // 转换成成file文件
      let fileY = dataURLtoFile(form.picture, file.file.name);
      resolve(fileY)
      // 压缩后的file文件，把上传即可fileY

    };
  })
}

// bas64转行成file文件
export function base64ToFile(base64, fileName) {
  return new Promise((resolve) => {
      let arr = base64.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bytes = atob(arr[1]);
      let n = bytes.length
      let ia = new Uint8Array(n);
      while (n--) {
          ia[n] = bytes.charCodeAt(n);
      }
      resolve(new File([ia], fileName, { type: mime }));
  })
}

